import { Update } from '@ngrx/entity';

import {
    emptyDatiqUserModalInfo,
    IDatiqUser,
    IDatiqUserModalInfo,
    IDatiqUserModals,
} from '../models';
import { State } from './datiq-user.reducer';

export const updateViewModalStateToUser: (
    modalId: string,
    state?: State
) => Update<IDatiqUser> = (
    modalId: string,
    state?: State
): Update<IDatiqUser> => {
    const modal: IDatiqUserModalInfo = getModal(state, modalId);
    const oldModals: IDatiqUserModals =
        state?.entities?.[state?.selectedId]?.modals;

    return !!modal
        ? {
              id: state?.selectedId,
              changes: {
                  modals: {
                      ...oldModals,
                      [modalId]: {
                          ...getModal(state, modalId),
                          first: false,
                      },
                  },
              },
          }
        : {
              id: state?.selectedId,
              changes: {
                  modals: {
                      ...oldModals,
                      [modalId]: {
                          ...emptyDatiqUserModalInfo,
                          first: false,
                      },
                  },
              },
          };
};
export const updateShowAgainModalStateToUser: (
    modalId: string,
    state?: State
) => Update<IDatiqUser> = (
    modalId: string,
    state?: State
): Update<IDatiqUser> => {
    const modal: IDatiqUserModalInfo = getModal(state, modalId);
    const showAgain: boolean = getShowAgain(modal);
    const oldModals: IDatiqUserModals =
        state?.entities?.[state?.selectedId]?.modals;

    return !!modal
        ? {
              id: state?.selectedId,
              changes: {
                  modals: {
                      ...oldModals,
                      [modalId]: {
                          ...getModal(state, modalId),
                          showAgain: showAgain,
                          first: false,
                      },
                  },
              },
          }
        : {
              id: state?.selectedId,
              changes: {
                  modals: {
                      ...oldModals,
                      [modalId]: {
                          ...emptyDatiqUserModalInfo,
                          showAgain: showAgain,
                          first: false,
                      },
                  },
              },
          };
};
const getShowAgain: (modal: IDatiqUserModalInfo) => boolean = (
    modal: IDatiqUserModalInfo
) => {
    return !!modal && modal?.showAgain ? !modal.showAgain : true;
};

const getModal: (state: State, modalId: string) => IDatiqUserModalInfo = (
    state: State,
    modalId: string
): IDatiqUserModalInfo => {
    return state?.entities[state?.selectedId]?.modals?.[modalId];
};
